import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Customer } from "../state/types"

export const useCustomerActions = () => {
    const saveActions = useSaveActions()

    const saveCustomer = (customer: Customer) => {
        const { save } = saveActions()
        return save(TableName.CUSTOMERS, customer) as Promise<Customer>
    }

    const saveCustomers = (customers: Customer[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.CUSTOMERS, customers) as Promise<Customer[]>
    }

    const removeCustomer = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CUSTOMERS, id)
    }

    return {
        saveCustomer,
        saveCustomers,
        removeCustomer
    }
}
